import VueI18n from "vue-i18n";

export default class LocaleLoader {
  private i18n: VueI18n;
  private currency: string;
  private _locale: string;
  private readonly minimumFractionDigits: number;
  private readonly maximumFractionDigits: number;

  constructor(
    i18n: VueI18n,
    locale: string,
    currency: string,
    minimumFractionDigits: number,
    maximumFractionDigits: number,
  ) {
    this.i18n = i18n;
    this._locale = locale;
    this.currency = currency;
    this.minimumFractionDigits = minimumFractionDigits;
    this.maximumFractionDigits = maximumFractionDigits;
  }

  get locale(): string {
    return this._locale;
  }

  async changeLocale(locale: string) {
    this._locale = locale;

    await this.loadLocale();

    this.changeNumberFormat();
    this.i18n.locale = locale;
  }

  changeCurrency(currency: string) {
    this.currency = currency;
    this.changeNumberFormat();
    this.i18n.locale = this.locale;
  }

  private changeNumberFormat() {
    this.i18n.mergeNumberFormat(this.locale, {
      currency: {
        style: "currency",
        currency: this.currency,
        minimumFractionDigits: this.minimumFractionDigits,
        maximumFractionDigits: this.maximumFractionDigits,
      },
    });

    this.i18n.mergeNumberFormat(this.locale, {
      percent: {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
    });
  }

  private async loadLocale(): Promise<void> {
    const locale = this._locale;

    const messages = await import(
      /* webpackChunkName: "/locales/[request]" */
      /* webpackInclude: /(cs|en|es|sk|hr|hu|de|vi|pl|ro|ru|it|pt|fr|zh|sl)\.json/ */
      "@/locales/" + locale + ".json"
    );

    const countries = await import(
      /* webpackChunkName: "/locales/countries/[request]" */
      /* webpackInclude: /(cs|en|es|sk|hr|hu|de|vi|pl|ro|ru|it|pt|fr|zh|sl)\.json/ */
      "i18n-iso-countries/langs/" + locale
    );

    const countriesExtended = await import(
      /* webpackChunkName: "/locales/countries-extended/[request]" */
      /* webpackInclude: /(cs|en|es|sk|hr|hu|de|vi|pl|ro|ru|it|pt|fr|zh|sl)\.json/ */
      "@/locales/countries-extended/" + locale + ".json"
    );

    const tmpCountries = countries.countries;

    for (const index in tmpCountries) {
      if (Array.isArray(tmpCountries[index])) {
        tmpCountries[index] = tmpCountries[index].shift();
      }

      if (this.locale === "en" && index === "TW") {
        tmpCountries[index] = "Taiwan";
      }
    }

    for (const index in countriesExtended.countries) {
      countries.countries[index] = countriesExtended.countries[index];
    }

    messages.countries = countries.countries;

    this.i18n.mergeLocaleMessage(locale, messages);
  }
}
